import { closestCenter, DndContext, DragEndEvent, DragOverlay, DragStartEvent, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { restrictToParentElement, restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Stack } from "@mui/material";
import React, { useCallback, useState } from "react";
import { CheckListItemType } from "../check-list/CheckList";
import { CheckListItem } from "../check-list/CheckListItem";



export type DndCheckListProps = {
    items: CheckListItemType[];
    onItemClick: (item: CheckListItemType) => void;
    onListReordered?: (items: CheckListItemType[]) => void;
    //filter?: (item: CheckListItemType) => boolean;
    icon?: React.ReactNode;
    checkedIcon?: React.ReactNode;
    onItemMove?: (oldIndex: number, newIndex: number) => void;
};

export function DndCheckList(
    {
        items,
        onItemClick,
        onListReordered,
        //filter,
        icon,
        checkedIcon,
        onItemMove
    }: DndCheckListProps) {

    const [draggingItem, setDraggingItem] = useState<CheckListItemType | undefined>(undefined);


    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                delay: 0,
                tolerance: 5
            }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );
    


    function onDragStart(event: DragStartEvent) {
        const item = items.find(o => o.key === event.active.id);
        setDraggingItem(item);
    }

    function onDragEnd(event: DragEndEvent) {
        const { active, over } = event;

        if (active.id !== over?.id) {
            const oldIndex = items.findIndex(o => o.key === active.id);
            const newIndex = items.findIndex(o => o.key === over?.id);

            if (oldIndex !== undefined && newIndex !== undefined) {
                if (onItemMove) {
                    onItemMove(oldIndex, newIndex);
                }

                if (onListReordered) {
                    const models = [...items as CheckListItemType[]];

                    const b = { ...models[oldIndex] };

                    models.splice(oldIndex, 1);
                    models.splice(newIndex, 0, b);

                    let i = 0;
                    models.forEach(o => o.order = i++);

                    onListReordered(models);
                }
            }
        }

        setDraggingItem(undefined);
    }


    const renderItem = useCallback((index: number, item: CheckListItemType) => {
        return (
            <CheckListItem
                id={item.key}
                key={item.key}
                displayText={item.displayText}
                onClick={() => onItemClick({ ...item, checked: !item.checked })}
                checked={item.checked}
                icon={icon}
                checkedIcon={checkedIcon}
                enableDnd={true}
                active={item.active}
                disabled={item.disabled}
            />
        );
    },
        [
            checkedIcon,
            icon,
            onItemClick
        ]);

    return (
        <Stack
            direction='column'
            sx={{
                flex: '1 1 auto',
                overflow: 'hidden',
                overflowY: 'auto'
            }}>
            <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
                modifiers={[restrictToVerticalAxis, restrictToParentElement]}
            >

                <SortableContext
                    items={items.map(o => o.key)}
                    strategy={verticalListSortingStrategy}
                >

                    {items.map((o, index) =>

                        renderItem(index, o)
                    )}

                    <DragOverlay>
                        {draggingItem &&
                            renderItem(999999, draggingItem)
                        }
                    </DragOverlay>

                </SortableContext>
            </DndContext>
        </Stack>
    );
}


